import { SecondaryStatusRoboticMowerEnum } from '@uptime-bff/api-contract';

interface StatusTranslation {
  status: {
    operationalStatus: {
      OK: string;
      OK_WITH_INFO: string;
      WARNING: string;
      CRITICAL: string;
      UNKNOWN: string;
      UNKNOWN_WITH_ISSUES: string;
    };
    secondaryStatus: {
      ALARM_RAISED: string;
      CHARGING: string;
      CLOUD_SYNCHRONIZATION_REQUESTED: string;
      DAMAGED: string;
      ERROR: string;
      FULLY_CHARGED: string;
      MOWING: string;
      NO_CONNECTION: string;
      ON_BATTERY: string;
      OPERABLE: string;
      PARKED: string;
      PAUSED: string;
      PLUGGED_IN: string;
      POWER_SUPPLY_UNKNOWN: string;
      PREPARING: string;
      STOPPED: string;
      THEFT_ALARM: string;
      TRANSPORTING: string;
      TURNED_OFF: string;
      additionalStatus: {
        ERROR_FATAL_ERROR: string;
        ERROR_PROBLEM_DETECTED: string;
        PAUSED_ACTION_REQUIRED: string;
        PAUSED_RUNS_MANUALLY: string;
        PARKED_AT_MAINTENANCE_POINT: string;
        PARKED_TEMPORARILY: string;
        PARKED_UNTIL_FURTHER_NOTICE: string;
        PREPARING_WAIT: string;
        STOPPED_ACTION_REQUIRED: string;
      };
    };
  };
}

enum SecondaryStatusRoboticMowerOpertaingEnum {
  OPERATING = 'OPERATING',
}

const ExtendedSecondaryStatusRoboticMowerEnum = {
  ...SecondaryStatusRoboticMowerEnum,
  ...SecondaryStatusRoboticMowerOpertaingEnum,
};

export { ExtendedSecondaryStatusRoboticMowerEnum };
export default StatusTranslation;
